var MDB = window.MDB || {};;

(function ($) {
    // functions for unauthenticated users
    $.extend(MDB, {
        /** 
         * Startup function, executed when dom is ready
        */
        bootUnauthenticated: function () {
            if (localStorage) {            
                //$('.remembermail')
                var email = localStorage["r_email"];
                if (email) {
                    $('.remembermail').prop('checked', true);
                    $('.emailfield').val(email);
                }
                $('.btn-login').bind('click', function(e) {
                    if ($('.remembermail').prop('checked')) {
                        localStorage["r_email"] = $('.emailfield').val();
                    } else {
                        localStorage["r_email"] = "";
                        if (localStorage.removeItem) {
                            localStorage.removeItem("r_email");
                        }
                    }
                });

                // Auto-submit language form when user click on one of the choices.
                $("input[name='culture']").bind('change', function () {
                    $(this).parents("form").submit();
                });
            }
        }
    });

    //schedule boot function for domready
    $(function() {
        MDB.bootUnauthenticated();
    });
})(jQuery);